import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { BaseServiceService } from "../../services/base-service.service";
import {
  ModalNotifyComponent,
  ModalNotifyTypes,
} from "../modal-notify/modal-notify.component";
import { DataTableComponent } from "../controls/data-table/data-table.component";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { AppData } from "../../helpers/app-data";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { lastValueFrom, Subscription } from "rxjs";

declare var fabric: any;

@Component({
  selector: "app-usuarios",
  templateUrl: "./usuarios.component.html",
  styleUrl: "./usuarios.component.css",
})
export class UsuariosComponent implements OnInit {
  @ViewChild(DataTableComponent) dataTableComponent!: DataTableComponent;
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  dialogComponentCreateUsuario: any;
  dialogComponentCambiarContraseña: any;
  dialogComponentEditUsuario: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idUsuario: any;
  showPassword: boolean = false;
  private userValidationTypeSubscription: Subscription | null = null;
  userValidationType: string | null = null;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: any;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];
  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";
  dtTrigger: any;
  valorCompartido: any;
  validateDel: boolean = false;
  getDataTableUsuario: any = ["Usuario", "GetDataTableUsuario"];
  roles: any[] = [];
  selectRolIsOpen = false;
  usuarioObj: Usuario;
  userForm: FormGroup;
  passwordForm: FormGroup;
  booleanColumnRenderer = (data: any, type: any, row: any, meta: any) => {
    if (type === "display") {
      return `<input type="checkbox" disabled ${data ? "checked" : ""}>`;
    }
    return data;
  };

  columnas = [
    { title: "Email", data: "Email" },
    { title: "Usuario", data: "NombreUsuario" },
    { title: "Rol", data: "NombreRol", orderable: false },
    { title: "Identificacion", data: "Identificacion" },
    {
      title: "Activo",
      data: "Activo",
      render: this.booleanColumnRenderer,
      orderable: false,
    },
  ];

  constructor(
    private baseService: BaseServiceService,
    private renderer: Renderer2,
    private http: HttpClient,
    private _formBuilder: FormBuilder
  ) {
    this.usuarioObj = new Usuario();
    this.formInit();
  }

  /* Datatable */

  ngOnInit(): void {
    this.userValidationTypeSubscription =
      this.baseService.currentUserValidationType.subscribe((validationType) => {
        this.userValidationType = validationType;
      });

    if (this.userValidationType) {
      if (this.userValidationType == "BD") {
        this.dtOptButtons.push(
          {
            "button-id": "btnEdit",
            "button-icon": "ms-Icon--EditNote",
            "button-tooltip": "Editar",
          },
          {
            "button-id": "btnPassword",
            "button-icon": "ms-Icon--Permissions",
            "button-tooltip": "Cambiar contraseña",
          } /* ,
        /*  {'button-id': 'btnDelete', 'button-icon': 'ms-Icon--Delete'} */
        );
      } else {
        this.dtOptButtons.push({
          "button-id": "btnEdit",
          "button-icon": "ms-Icon--EditNote",
          "button-tooltip": "Editar",
        });
      }
    }

    this.userForm
      .get("IdTipoIdentificacion")
      ?.valueChanges.subscribe((tipo: string) => {
        const identificacionControl = this.userForm.get("Identificacion");

        if (!identificacionControl) return;

        // Limpia las validaciones anteriores
        identificacionControl.clearValidators();
        
        // Aplica nuevas validaciones según el tipo seleccionado
        switch (tipo) {
          case "1" :
          case "2" :
          case "3" : // Cedula, RegistroCivil, TI
            identificacionControl.setValidators([
              Validators.required,
              Validators.pattern("^[0-9]+$"),
              Validators.maxLength(10),
            ]);
            break;

          

          default:
            identificacionControl.setValidators([Validators.required]);
            break;
        }

        // Aplica los cambios al control
        identificacionControl.updateValueAndValidity();
      });

    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric["Spinner"](SpinnerElements[i]);
    }
  }

  formInit() {
    this.userForm = this._formBuilder.group({
      Email: new FormControl("", [
        Validators.required,
        Validators.email,
        Validators.maxLength(100),
      ]),
      NombreUsuario: new FormControl("", [
        Validators.required,
        Validators.maxLength(100),
      ]),
      Password: new FormControl("", [
        Validators.required,
        Validators.maxLength(100),
      ]),
      Idrol: new FormControl("", [Validators.required]),
      IdTipoIdentificacion: new FormControl("", [Validators.required]),
      Identificacion: new FormControl("", [
        Validators.required,
        Validators.maxLength(20),
        Validators.pattern("^[0-9]+$"),
      ]),
      Activo: new FormControl(false),
    });

    this.passwordForm = this._formBuilder.group({
      Password: new FormControl("", [
        Validators.required,
        Validators.maxLength(100),
      ]),
    });
  }
  onIdentificacionInput(event: Event): void {
    const tipo = this.userForm.get('IdTipoIdentificacion')?.value;

    // Solo filtra cuando es tipo cédula o TI
    if ( tipo ==="1" ||tipo === "2" || tipo === "3") {
      const keyboardEvent = event as KeyboardEvent;
      const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
      const isNumber = /^[0-9]$/.test(keyboardEvent.key);

      if (!isNumber && !allowedKeys.includes(keyboardEvent.key)) {
        keyboardEvent.preventDefault(); // Bloquea la tecla
      }
    }
  }
  ngAfterViewInit(): void {
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.on("draw", () => {
    //     this.attachClickEvents();
    //   });
    // });
  }

  ngOnDestroy(): void {
    // Destroy the DataTables when the component is destroyed to prevent memory leaks
    if (this.dtElement) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.off("draw");
      });
    }

    if (this.userValidationTypeSubscription) {
      this.userValidationTypeSubscription.unsubscribe();
    }
  }

  // attachClickEvents(): void {
  //   const editButtons = document.querySelectorAll("#btnEdit");
  //   const deleteButtons = document.querySelectorAll("#btnDelete");

  //   editButtons.forEach((button) => {
  //     this.renderer.listen(button, "click", (event) => {
  //       const id = button.getAttribute("data-id");
  //       this.idUsuario = id;
  //       this.abrirModalEditar();
  //     });
  //   });

  //   deleteButtons.forEach((button) => {
  //     this.renderer.listen(button, "click", (event) => {
  //       const userId = button.getAttribute("data-id");
  //       this.delete(Number(userId));
  //     });
  //   });
  // }

  controlName(form: FormGroup, nameControl: string): AbstractControl {
    return form.get(nameControl)!;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  gridLoaded(event: any) {
    this.dtInstance = event["table"];
  }

  customClick(event: any) {
    try {
      
      this.idUsuario = event["data-id"];

      switch (event["button-id"]) {
        case "btnEdit":
          this.abrirModalEditar();
          break;
        case "btnDelete":
          this.delete();
          break;
        case "btnPassword":
          this.abrirmodalcontraseña();
          break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  delete() {
    try {
      // Llamamos a triggerShowModal para abrir el modal de confirmación
      this.baseService.triggerShowModal(
        "Eliminar Usuario",
        "¿Seguro que desea eliminar el Usuario?",
        ModalNotifyTypes.Warning,
        true
      );

      // Manejamos el evento actionConfirmed del ModalNotifyComponent
      this.modalNotifyComponent.actionConfirmed.subscribe(
        (confirmed: boolean) => {
          if (confirmed) {
            // Si se confirma la eliminación, procedemos con la llamada a la API para eliminar
            this.baseService
              .delete("Usuario/BorrarUsuario", this.idUsuario)
              .then(() => {
                this.reloadDataTable();
                this.baseService.triggerShowModal(
                  "Usuario Eliminado",
                  "Usuario Eliminado Correctamente",
                  ModalNotifyTypes.Success,
                  false
                );
              });
          } else {
            // Si se cancela la eliminación, no hacemos nada
          }
        }
      );
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error al enviar el formulario:",
        error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  reloadDataTable(): void {
    // Obtener la instancia de DataTable y recargar los datos
    //this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    this.dtInstance.ajax.reload(undefined, false); // false para mantener la página actual después de la recarga
    //});
  }

  abrirmodalcontraseña() {
    const dialog = document.querySelector(".modal-contraseña");
    this.dialogComponentCambiarContraseña = new fabric["Dialog"](dialog);
    this.dialogComponentCambiarContraseña.open();
    // this.controlName(this.passwordForm, "Password").setValidators([
    //   Validators.required,
    //   Validators.maxLength(100),
    // ]);
    // this.controlName(this.passwordForm, "Password").updateValueAndValidity();
  }

  async updatePassword() {
    try {
      if (this.idUsuario) {
        this.botonProcesando = true;

        let password = this.passwordForm.get("Password")!.value;

        const response = await lastValueFrom(
          this.http.post<any>(
            `${AppData.API_URL}Usuario/ActualizarClaveUsuario?Id=${this.idUsuario}`,
            { Password: password }
          )
        );

        
        if (!response.Ok) {
          this.dialogComponentCambiarContraseña.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al actualizar contraseña",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
        } else {
          this.dialogComponentCambiarContraseña.close();
          this.baseService.triggerShowModal(
            "Contraseña Actualizada",
            "Se ha actualizado el registro correctamente ",
            ModalNotifyTypes.Success,
            false
          );
          this.reloadDataTable();
        }
      }

      this.botonProcesando = false;

      this.clearFormPassword();
    } catch (error: any) {
      this.dialogComponentCambiarContraseña.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }
  initializeFabric() {
    var DropdownHTMLElements = document.querySelectorAll(".dropdown");
    for (var i = 0; i < DropdownHTMLElements.length; ++i) {
      var Dropdown = new fabric["Dropdown"](DropdownHTMLElements[i]);
    }
  }

  abrirModalCrear() {
    $("#dialogCreateEdit").html("Crear Usuario");
    $("#btnCreateEdit").html("Crear");
    this.clearFormUsuarioCreado();
    // this.controlName(this.userForm, "Password").setValidators([()
    //   Validators.required,
    //   Validators.maxLength(100),
    // ]);
    this.userForm.controls["Email"].enable();
    this.userForm.controls["Activo"].setValue(true);

    //this.controlName(this.userForm, "Password").updateValueAndValidity();
    const dialog = document.querySelector(".create-usuarios");
    this.dialogComponentCreateUsuario = new fabric["Dialog"](dialog);
    this.dialogComponentCreateUsuario.open();
  }

  async crearEditarUsuario() {
    //this.validateUsuario();
    // if (this.validateUsuario()) {

    this.botonProcesando = true;
    this.usuarioObj.Email = this.userForm.get("Email")!.value;
    this.usuarioObj.NombreUsuario = this.userForm.get("NombreUsuario")!.value;
    this.usuarioObj.Password = this.userForm.get("Password")!.value;
    this.usuarioObj.Idrol = this.userForm.get("Idrol")!.value;
    this.usuarioObj.IdTipoIdentificacion = this.userForm.get(
      "IdTipoIdentificacion"
    )!.value;
    this.usuarioObj.Identificacion = this.userForm.get("Identificacion")!.value;
    this.usuarioObj.Activo = this.userForm.get("Activo")!.value;
    this.usuarioObj.TodasTareas = true;
    this.usuarioObj.TodosFormularios = true;
    this.usuarioObj.TodosProcesos = true;
    try {
      if (this.idUsuario) {
        if (!this.usuarioObj.Activo) {
          
          let notificaciones : any = await lastValueFrom(
            this.baseService.getAll(
              `EjecucionTarea/ValidarTareasInactivarUsuario?IdUsuarioInactivar=${this.idUsuario}`
            )
          );
          if (notificaciones.Ok && notificaciones.Data.TotalEjecuciones > 0) {
            this.baseService.triggerShowModal(
              "El Usuario tiene tareas asignadas",
              "No se puede cambiar el estado del usuario",
              ModalNotifyTypes.Danger,
              false
            );
            this.userForm.controls["Activo"].setValue(true);
          } else {
            await this.updateUsuario();
          }
        } else {
          
          await this.updateUsuario();
        }

        // Manejamos el evento actionConfirmed del ModalNotifyComponent
      } else {
        const response = await this.baseService.create(
          "Usuario/CrearUsuario",
          this.usuarioObj
        );

        if (!response.Ok) {
          //this.dialogComponentCreateUsuario.close();

          let mensajeError = "<ul>";
          response.ValidationErrors.forEach((error: any) => {
            mensajeError += `<li>${error}</li>`;
          });
          mensajeError += "</ul>";

          this.baseService.triggerShowModal(
            "Error al crear usuario",
            mensajeError,
            ModalNotifyTypes.Danger,
            false
          );
        } else {
          this.dialogComponentCreateUsuario.close();
          this.baseService.triggerShowModal(
            "Usuario Creado",
            "Se ha almacenado el registro correctamente ",
            ModalNotifyTypes.Success,
            false
          );
        }
      }

      this.botonProcesando = false;
      this.reloadDataTable();
      //this.clearFormUsuarioCreado();
    } catch (error: any) {
      // this.dialogComponentCreateUsuario.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
    // } else {
    //   this.botonProcesando = false;
    // }
  }

  async updateUsuario() {
    const response = await this.baseService.update(
      "Usuario/ActualizarUsuario",
      this.idUsuario,
      this.usuarioObj
    );

    if (!response.Ok) {
      
      let mensajeError = "<ul>";
      response.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        "Error al actualizar usuario",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
    } else {
      
      this.dialogComponentCreateUsuario.close();
      setTimeout(() => {
        this.baseService.triggerShowModal(
          "Usuario Actualizado",
          "Se ha actualizado el registro correctamente ",
          ModalNotifyTypes.Success,
          false
        );
      }, 100);
    }
  }

  async abrirModalEditar() {
    try {
      if (this.idUsuario !== null) {
        const responseById = await this.baseService.getById(
          "Usuario/GetUsuario",
          this.idUsuario
        );
        if (responseById.Data) {
          const Data = responseById.Data;
          this.userForm.controls["Email"].setValue(Data.Email);
          this.userForm.controls["Email"].disable();
          this.userForm.controls["NombreUsuario"].setValue(Data.NombreUsuario);
          this.userForm.controls["Password"].setValue(Data.Password);
          this.userForm.controls["IdTipoIdentificacion"].setValue(
            Data.IdTipoIdentificacion
          );
          this.userForm.controls["Identificacion"].setValue(
            Data.Identificacion
          );
          this.userForm.controls["Idrol"].setValue(Data.Idrol);
          this.userForm.controls["Activo"].setValue(Data.Activo);
          // this.usuarioObj.Email = Data.Email;
          // this.usuarioObj.NombreUsuario = Data.NombreUsuario;
          // this.usuarioObj.Password = Data.Password;
          // this.usuarioObj.IdTipoIdentificacion = Data.IdTipoIdentificacion;
          // this.usuarioObj.Identificacion = Data.Identificacion;
          // this.usuarioObj.Idrol = Data.Idrol;
          // this.usuarioObj.Activo = Data.Activo;

          $("#dialogCreateEdit").html("Editar Usuario");
          $("#btnCreateEdit").html("Actualizar");
          this.controlName(this.userForm, "Password").setValidators(null);
          this.controlName(this.userForm, "Password").updateValueAndValidity();

          const dialog = document.querySelector(".create-usuarios");

          this.dialogComponentCreateUsuario = new fabric["Dialog"](dialog);
          this.dialogComponentCreateUsuario.open();
        }
      }
    } catch (error: any) {
      this.baseService.triggerShowModal(
        "Error",
        error.Error,
        ModalNotifyTypes.Danger,
        false
      );
    }
  }

  clearFormUsuario() {
    this.baseService.triggerShowModal(
      "Cancelar creacion de Usuario",
      "¿Seguro que desea cancelar la creacion del Usuario?",
      ModalNotifyTypes.Warning,
      true
    );

    //this.baseService.clearForm();

    this.modalNotifyComponent.actionConfirmed.subscribe(
      (confirmed: boolean) => {
        if (confirmed) {
          this.usuarioObj = new Usuario();
          this.userForm.reset();
          this.idUsuario = null;
          this.dialogComponentCreateUsuario.close();
        } else {
          // Si se cancela la eliminación, no hacemos nada
        }
      }
    );
  }

  clearFormUsuarioCreado() {
    this.usuarioObj = new Usuario();
    this.userForm.reset();
    this.idUsuario = null;
  }

  catch(error: any) {
    this.baseService.triggerShowModal(
      "Error al enviar el formulario:",
      error,
      ModalNotifyTypes.Danger,
      false
    );
  }
  clearFormPassword() {
    this.passwordForm.reset();
    this.idUsuario = null;
  }


  
}

export class Usuario {
  Email: string;
  NombreUsuario: string;
  Password: string;
  Idrol: number | undefined;
  NombreRol: string;
  IdTipoIdentificacion: number | undefined;
  Identificacion: string;
  TodosProcesos: boolean | undefined;
  TodasTareas: boolean | undefined;
  TodosFormularios: boolean | undefined;
  Activo: boolean | undefined;

  constructor() {
    this.Email = "";
    this.NombreUsuario = "";
    this.Password = "";
    this.Idrol = undefined;
    this.NombreRol = "";
    this.IdTipoIdentificacion = undefined;
    this.Identificacion = "";
    this.TodosProcesos = undefined;
    this.TodasTareas = undefined;
    this.TodosFormularios = undefined;
    this.Activo = undefined;
  }
}
